import { accountStatsReducer } from "cortex/ui/src/redux-store/ui-state/account-stats/reducers";

import { contentGroupFormReducer } from "./content-group-form/reducers";
import { deviceEventsReducer } from "./device-events/reducers";
import { deviceEventsV3Reducer } from "./device-events-v3/reducers";
import { deviceIncidentsReducer } from "./device-incidents/reducers";
import { deviceResourceReducer } from "./device-resources/reducers";
import { deviceStatsReducer } from "./device-stats/reducers";
import { eventsV3Reducer } from "./events-v3/reducers";
import { incidentsReducer } from "./incidents/reducers";
import { mediaLibraryReducer } from "./media-library";
import { playerVersionsReducer } from "./player-versions/reducers";
import { uptimeReportReducer } from "./report-uptime/reducers";
import { deviceUptimeReportReducer } from "./report-uptime-device/reducers";
import { devicesUptimeReportReducer } from "./report-uptime-devices/reducers";
import { strategyDetailReducer } from "./strategy/reducers";
import { tagsReducer } from "./tags/reducers";

type PageReducer = (state: unknown, action: unknown) => unknown;
const asPageReducer = (reducer: unknown) => reducer as PageReducer;

// Define the ui-state store.
const pageReducers: Record<string, PageReducer> = {
  accountStats: asPageReducer(accountStatsReducer),
  contentGroupForm: asPageReducer(contentGroupFormReducer),
  deviceEvents: asPageReducer(deviceEventsReducer),
  deviceEventsV3: asPageReducer(deviceEventsV3Reducer),
  deviceIncidents: asPageReducer(deviceIncidentsReducer),
  deviceResources: asPageReducer(deviceResourceReducer),
  deviceStats: asPageReducer(deviceStatsReducer),
  devicesUptimeReport: asPageReducer(devicesUptimeReportReducer),
  deviceUptimeReport: asPageReducer(deviceUptimeReportReducer),
  eventsV3: asPageReducer(eventsV3Reducer),
  incidents: asPageReducer(incidentsReducer),
  mediaLibrary: asPageReducer(mediaLibraryReducer),
  playerVersions: asPageReducer(playerVersionsReducer),
  strategyDetail: asPageReducer(strategyDetailReducer),
  tags: asPageReducer(tagsReducer),
  uptimeReport: asPageReducer(uptimeReportReducer),
};

export { pageReducers };
